import { render } from "./WCNavBar.vue?vue&type=template&id=dede750c&scoped=true"
import script from "./WCNavBar.vue?vue&type=script&lang=js"
export * from "./WCNavBar.vue?vue&type=script&lang=js"

import "./WCNavBar.vue?vue&type=style&index=0&id=dede750c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dede750c"]])

export default __exports__